import { render } from "./LocationForm.vue?vue&type=template&id=b3468658&ts=true"
import script from "./LocationForm.vue?vue&type=script&lang=ts"
export * from "./LocationForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__